/**
 * Indexer API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
package indexer.codegen

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

/**
 *
 * @param id
 * @param side
 * @param liquidity
 * @param type
 * @param market
 * @param marketType
 * @param price
 * @param size
 * @param fee
 * @param affiliateRevShare
 * @param createdAt
 * @param createdAtHeight
 * @param orderId
 * @param clientMetadata
 * @param subaccountNumber
 * @param builderFee
 * @param builderAddress
 * @param orderRouterAddress
 * @param orderRouterFee
 */
@JsExport
@Serializable
data class IndexerFillResponseObject(

    val id: kotlin.String? = null,
    val side: IndexerOrderSide? = null,
    val liquidity: IndexerLiquidity? = null,
    val type: IndexerFillType? = null,
    val market: kotlin.String? = null,
    val marketType: IndexerMarketType? = null,
    val price: kotlin.String? = null,
    val size: kotlin.String? = null,
    val fee: kotlin.String? = null,
    val affiliateRevShare: kotlin.String? = null,
    val createdAt: IndexerIsoString? = null,
    val createdAtHeight: kotlin.String? = null,
    val orderId: kotlin.String? = null,
    val clientMetadata: kotlin.String? = null,
    val subaccountNumber: kotlin.Int? = null,
    val builderFee: kotlin.String? = null,
    val builderAddress: kotlin.String? = null,
    val orderRouterAddress: kotlin.String? = null,
    val orderRouterFee: kotlin.String? = null
)
